import React from "react";
import { Grid, styled, Typography, Box } from "@mui/material";
import FormComponent from "../../components/global/FormComponent";
import Email from "@mui/icons-material/Email";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import Header from "../../components/global/Header";
import secureLocalStorage from "react-secure-storage";

const formConfig = [
  {
    field: {
      type: "text",
      title: "Subject",
      id: "subject",
      name: "subject",
      placeholder: "",
      required: true,
      error: {
        condition: (value) => value.trim() === "",
        message: "Subject is required",
      },
    },
  },
  {
    field: {
      type: "text",
      title: "Message",
      id: "message",
      name: "message",
      placeholder: "Message",
      required: true,
      error: {
        condition: (value) => value.trim() === "",
        message: "Message is required",
      },
    },
  },
];
const LeftSideContainer = styled(Grid)({
  backgroundColor: "#201939",
  borderRadius: "5px",
  padding: "3vw",
  color: "white",
});
const QueryForm = ({ isSubscribe }) => {
  const handleAddOrUpdate = async (formData) => {
    const userDataString = secureLocalStorage.getItem("userInfo");
    const userData = JSON.parse(userDataString);
    formData.feedback_type = "feedback";
    formData.sender_name = userData.name;
    formData.sender_email = userData.email;
    console.log(formData);
    try {
      // Make a POST request to the backend endpoint
      const response = await axios.post(
        "http://127.0.0.1:8000/feedback/create-query",
        formData
      );

      // Handle response based on server's response
      if (response.status === 200) {
        toast.success("Successfully sent!");

        // Redirect user or show a success message
      } else {
        // Handle other status codes or errors
        toast.error("Failed to save!", response.error);
        // Display an error message to the user
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      {isSubscribe == true ? (
        <Box m={"auto 2vw"}>
          <Box
            margin="auto"
            backgroundColor="#222222"
            borderRadius="5px"
            m={"3vw"}
          >
            <Grid container>
              <LeftSideContainer item xs={12} sm={4}>
                <Box
                  height="65%"
                  display="flex"
                  flexDirection="column"
                  justifyContent="space-between"
                  marginTop="3vw"
                >
                  <Typography variant="h4" fontWeight={600} paddingBottom={8}>
                    Contact Us
                  </Typography>
                  <Typography variant="body1" paddingBottom={6} maxWidth={172}>
                    Please use the form on the right to submit your inquiry
                    about our bot subscription. Fill out the required
                    information, and we will get back to you as soon as
                    possible.
                  </Typography>
                  <Typography variant="body1">
                    Want more information? Email us.
                  </Typography>
                  <Typography
                    variant="body1"
                    display="flex"
                    alignItems="center"
                  >
                    <Email style={{ marginRight: "8px" }} />
                    forexminer@example.com
                  </Typography>
                </Box>
              </LeftSideContainer>

              <Grid item xs={12} sm={8} sx={{ paddingTop: 5 }}>
                <FormComponent
                  formTitle="Get in Touch"
                  formConfig={formConfig}
                  buttonText={"Send Query"}
                  handleAddOrUpdate={handleAddOrUpdate}
                  noCrossIcon
                />
              </Grid>
            </Grid>
          </Box>
          <Toaster position="top-right" />
        </Box>
      ) : (
        <Box m="2vw">
          <Header subTitle="No Access" />
        </Box>
      )}
    </>
  );
};

export default QueryForm;
